import React from 'react';

import List from '@sv-support-sdk/ui-components/src/components/Lists/List';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import SortingDropdown from './components/SortingDropdown';
import PageContentInner from '../../components/Layout/Page/PageContentInner';
import SupportHistoryTabs from '../../components/Navigation/SupportHistoryTabs';
import TicketsHistory from '../TicketsHistory';
import ChatsHistory from '../ChatHistory';

import { $l } from '../../locales';
import { selectActiveTab } from '../../store/selectors/tickets';
import { ticketsActions } from '../../store/slices/tickets';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

const SupportHistory = () => {
  const activeTab = useAppSelector(selectActiveTab);
  const dispatch = useAppDispatch();

  return (
    <PageContentInner height="full">
      <List gap="16" direction="row" isWrapped justify="space-between">
        <Headline>{$l('TICKETS.SUPPORT_HISTORY')}</Headline>
        <SortingDropdown type={activeTab} />
      </List>
      <SupportHistoryTabs
        onTabClick={(tab) => dispatch(ticketsActions.setActiveTab(tab as 'tickets' | 'chats'))}
        type={activeTab}
      />
      {activeTab === 'tickets' ? <TicketsHistory /> : <ChatsHistory />}
    </PageContentInner>
  );
};

export default SupportHistory;
